import React, { useState, useEffect } from "react"
import * as styles from "./Footer.module.scss"
import { useLink, useSiteQuery } from "../../../hooks"
import LinkGroup from "../../../LinkGroup/LinkGroup"
import { Link } from "gatsby"
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa"
import { FaXTwitter } from "react-icons/fa6"
import { useSendEmail } from "../../../hooks/function/useSendEmail"
import LoadingSpinner from "../../Loader/Loader"

const Footer = () => {
  const {
    footerLogo,
    footerCopyrightText,
    footerItems,
    footerPrivacy,
    footerCopyrightItems,
    subscribeNewsletter,
  } = useSiteQuery()

  const [emailInput, setEmailInput] = useState("")
  const [sendEmail, { response, loading, error }] = useSendEmail()
  const [showThankYou, setShowThankYou] = useState(false)

  const submitHandler = async e => {
    e.preventDefault()
    if (!emailInput) return

    await sendEmail(emailInput)
    setEmailInput("")          // Clear input field
    setShowThankYou(true)      // Show thank you message
  }

  useEffect(() => {
    if (showThankYou) {
      const timer = setTimeout(() => {
        setShowThankYou(false)
      }, 3000)

      return () => clearTimeout(timer)
    }
  }, [showThankYou])

  return (
    <footer className="bg-primary-blue c-padding">
      <div className={`container flex flex-col ${styles.footerContainer}`}>
        <div className={`flex ${styles.footerMenu}`}>
          <div className={styles.col1}>
            <Link to="#">
              <img
                src={footerLogo.file.url}
                alt={footerLogo.title}
                height={footerLogo.height}
                width={footerLogo.width}
                className={styles.footerLogo}
              />
            </Link>
            <p className={styles.paraSection}>
              Digitup aims to revolutionize web development with AI, creating
              SMART WEBSITES that deliver personalized, innovative online
              experiences.
            </p>
          </div>

          <div className={`c-padding ${styles.col2}`}>
            {footerItems.map(
              (item, index) =>
                item.__typename === "ContentfulComponentLinkGroup" && (
                  <LinkGroup key={index} item={item} />
                )
            )}

            <div className={styles.col3}>
              <h3 className={styles.footerPrivacy}>{subscribeNewsletter}</h3>

              <form className={styles.form} onSubmit={submitHandler}>
                <div className={styles.consent}></div>

                {showThankYou ? (
                  <p className={styles.thankYou}>Thank you</p>
                ) : (
                  <>
                    <input
                      type="email"
                      aria-label="Email"
                      autoComplete="email"
                      placeholder="Your email here"
                      className={`bg-white ${styles.email}`}
                      onChange={e => setEmailInput(e.target.value)}
                      value={emailInput}
                    />
                    <button
                      type="submit"
                      className={`onPrimaryOutline ${styles.joinButton}`}
                      disabled={loading}
                    >
                      Join
                    </button>
                    {/* {loading && <LoadingSpinner overLay={true} />} */}
                  </>
                )}
              </form>

              <h3 className={styles.subscribe}>
                {footerPrivacy.footerPrivacy}
              </h3>
            </div>
          </div>
        </div>

        <div className={`flex justify-between ${styles.copyrightText}`}>
          <p>{footerCopyrightText}</p>
          <ul className={styles.socialIcons}>
            <li className={styles.Icons}>
              <a
                href="https://www.instagram.com/digitupindia/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/digitupindia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.linkedin.com/company/digitupindia?trk=blended-typeahead"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://www.youtube.com/@digitupIndia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our YouTube"
              >
                <FaYoutube />
              </a>
              <a
                href="https://x.com/Digitupind"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit our X (formerly Twitter)"
              >
                <FaXTwitter />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default Footer
